import "./App.css";
import Home from "./pages/Home";
import "./fonts.css";
import { useState } from "react";
import MintInfo from "./assets/images/mintDetails.jpg"
import { Icon } from "@iconify/react";
import { FaClosedCaptioning } from "react-icons/fa";
import { RiCloseCircleLine } from "react-icons/ri";
import { Colors } from "./components/Colors";
import { CloseCircle } from "iconsax-react";

function App() {
  const [showOverlay, setShowOverlay] = useState(false);
  return (
    <div>
      <Home onPress={()=> setShowOverlay(true)} />
      {showOverlay && (
        <div
          onClick={() => setShowOverlay(false)}
          className="backdrop-blur-sm bg-white/30 fixed w-[100%] h-screen z-10 top-0 bottom-0 left-0 right-0 cursor-pointer flex max-md:items-center max-lg:items-start  justify-center px-5 py-5 max-md:space-x-0 max-lg:space-x-2 "
        >
          <img src={MintInfo} className=" md:w-[50%] object-fill aspect-square rounded-lg" alt="Mint Information"  />
          <CloseCircle variant="TwoTone" className="max-lg:flex max-md:hidden" size={50} color={Colors.ash} />
        </div>
      )}
    </div>
  );
}

export default App;
